import Personalization from 'theme/atoms/Personalization'
import * as t from './types'
import * as React from 'react'
import fetchBySku from 'utils/productListFetcher/bySku'

import { FetchContentResult } from 'utils/dy-hybrid/endpoints/fetchContent'

const mapDy =
  (prevProps: t.Props) => async (config: FetchContentResult<t.DyResponse>) => {
    const skus = config.skus.map((sku) => sku.sku)
    const products = await fetchBySku(
      skus,
      10
    )(0).then((result) => {
      const dataDict: Record<string, any> = {}
      for (const product of result.data) {
        dataDict[product.sku] = product
      }

      return {
        ...result,
        data: config.skus
          .map(({ sku, slotId }) => {
            if (dataDict[sku]) {
              const product = dataDict[sku]
              return {
                ...product,
                dyContext: {
                  decisionId: config.content.decisionId,
                  slotId: slotId || ''
                }
              }
            } else {
              return null
            }
          })
          .filter(Boolean)
      }
    })

    return {
      ...prevProps,
      context: {
        ...prevProps.context,
        products: products.data || prevProps.context.products
      },
      products: products.data || prevProps.context.products,
      skuList: skus,
      title: config.content.title,
      decisionId: config.context.decisionId
    }
  }

export default function withDy(
  Component: React.JSXElementConstructor<t.Props>
) {
  return function Wrapper(props: t.Props) {
    if (!props.dySelector) return <Component {...props} />

    return (
      <Personalization<t.Props, t.DyResponse>
        processResponse={mapDy(props)}
        selector={props.dySelector}
        showDefaultDataByControlGroup={props.showDefaultDataByControlGroup}
        shape={[
          'object',
          {
            title: 'string'
            // skus: [
            //   'array',
            //   [
            //     'object',
            //     {
            //       sku: 'string',
            //       slotId: 'string',
            //     },
            //   ],
            // ],
          }
        ]}
        initialData={{ ...props }}
        strategy="BLUR"
        render={(data) => <Component {...data} />}
      />
    )
  }
}
